import {useMutation, useQueryClient} from "@tanstack/react-query";
import {registerUserPagoMovilDataService} from "../services/account/registerUserPagoMovilData.service";
import {useAuthStore} from "../store/useAuth.store";

const usePutUserPagoMovilRegistrationData = () => {
  const queryClient = useQueryClient();
  const user = useAuthStore(state => state.user);

  const {data, isError, isPending, error, mutate, isSuccess} = useMutation({
    mutationKey: ["putUserPagoMovilRegistrationData"],
    mutationFn: registerUserPagoMovilDataService,
    onSuccess: () => {
      // Invalidate user-specific userData query to refetch updated user information
      queryClient.invalidateQueries({
        queryKey: ["userData", user?.email || user?.sub],
      });
      // Also invalidate general userData queries in case they exist
      queryClient.invalidateQueries({queryKey: ["userData"]});
    },
    onError: _error => {},
  });

  return {
    putUserPagoMovilData: mutate,
    data,
    isError,
    isPending,
    isSuccess,
    error,
  };
};

export default usePutUserPagoMovilRegistrationData;
